/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayIcon24Regular = forwardRef('MediaUiAPlayIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.25 4.798c0-1.372 1.507-2.21 2.673-1.487l11.604 7.202a1.75 1.75 0 0 1 0 2.974L7.923 20.689c-1.166.724-2.673-.114-2.673-1.487V4.798Zm1.882-.213a.25.25 0 0 0-.382.213v14.404a.25.25 0 0 0 .382.213l11.604-7.202a.25.25 0 0 0 0-.425L7.132 4.585Z" })));
});
